module.exports = __webpack_public_path__ + "static/google-sheets-93c15fee942980ea3bdb080efba5ab5a.svg";